import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { logEvent } from 'lib/analytics'
import { toBooleanString } from 'lib/helpers'

import { selectSettingsForGroups } from 'store/slices/settings'
import { selectTimelineFilters } from 'store/slices/timeline'
import { selectIsLoggedIn } from 'store/selectors'
import { useGetSettingQuery } from 'store/api/yay/user'

export const useLogEventTimelineFilter = () => {
  const timelineFilters = useSelector(selectTimelineFilters)
  const groupTimelineFilter = useSelector(selectSettingsForGroups)
  const isLoggedIn = useSelector(selectIsLoggedIn)

  const getSettingsRes = useGetSettingQuery(null, {
    skip: !isLoggedIn,
  })

  useEffect(() => {
    if (!getSettingsRes?.isFetching) {
      logEvent.timeline_filter_open({
        current_hide_hot_posts: toBooleanString(timelineFilters.hideHotPost),
        current_no_reply_public_timeline: toBooleanString(
          getSettingsRes?.data?.setting?.hide_reply_public_timeline
        ),
        current_no_reply_following_timeline: toBooleanString(
          getSettingsRes?.data?.setting?.hide_reply_following_timeline
        ),
        current_reply_group_timeline: toBooleanString(
          groupTimelineFilter?.hideRepliesOnTimeline
        ),
      })
    }
  }, [getSettingsRes?.isFetching])
}
